export const PROD = 'prod';

export const QA = 'qa';

export const STAGE = 'stage';

export const LOCAL = 'local';

export const DEV = 'development';
